import type { ToolState } from '../engine/Engine';

export const PEN_COLORS = [
  { name: 'Black', value: '#1a1a1a' },
  { name: 'Blue', value: '#1e4fd8' },
  { name: 'Red', value: '#d32f2f' },
  { name: 'Green', value: '#2e7d32' },
  { name: 'Purple', value: '#7b1fa2' },
  { name: 'Orange', value: '#ef6c00' },
] as const;

/** Page units at pressure 0.5 (1 unit = 0.21 mm). */
export const PEN_WIDTHS = [
  { name: 'Fine', value: 1.8 },
  { name: 'Medium', value: 3 },
  { name: 'Bold', value: 5 },
] as const;

export const HIGHLIGHTER_COLORS = [
  { name: 'Yellow', value: '#ffd400' },
  { name: 'Green', value: '#6ee26e' },
  { name: 'Pink', value: '#ff7eb6' },
] as const;
export const HIGHLIGHTER_WIDTH = 18;

export const DEFAULT_TOOL: ToolState = { tool: 'pen', color: PEN_COLORS[0].value, baseWidth: PEN_WIDTHS[1].value };
export const TOOL_KEY = 'toolState';

export interface ToolPrefs {
  pen: { color: string; baseWidth: number };
  highlighter: { color: string };
  active: 'pen' | 'highlighter';
}

export const DEFAULT_PREFS: ToolPrefs = {
  pen: { color: DEFAULT_TOOL.color, baseWidth: DEFAULT_TOOL.baseWidth },
  highlighter: { color: HIGHLIGHTER_COLORS[0].value },
  active: 'pen',
};

export function toolFromPrefs(p: ToolPrefs): ToolState {
  return p.active === 'pen'
    ? { tool: 'pen', ...p.pen }
    : { tool: 'highlighter', color: p.highlighter.color, baseWidth: HIGHLIGHTER_WIDTH };
}

/** Setting: use a desynchronized (low-latency) display canvas. Default on. */
export const LOW_LATENCY_KEY = 'lowLatencyInk';
